import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-steel px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg6w4hn3e2i">
        <h2 className="text-center text-[1.15rem] font-black uppercase text-white sm:text-[1.7rem]" data-id="element-20" data-mp="avcxel4e1k8y">
          5 PREMIUM <span className="text-gold" data-id="element-21" data-mp="ftms6um7aiu1">BONUSES INCLUDED</span>
        </h2>
        <div className="mt-2 space-y-2" data-id="element-22" data-mp="frto9n2z2cpq">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-4 border-gold bg-white px-2.5 py-2 shadow-sm" data-id="element-23" data-mp="1t3qs6c8qb0u">
              <h3 className="text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-[0.88rem]" data-id="element-24" data-mp="5tnnx9wtdemz">
                🎁 BONUS {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-25" data-mp="1ma8nd38hj84t">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}